import axios, { corsProxy } from '@/plugins/axios'

const PROXY = process.env.VUE_APP_PROXY_URI
const TRAVELANIUM_API_URI = process.env.VUE_APP_TRAVELANIUM_URI_NOTIFICATION

function request () {
  const req = axios.create()
  return corsProxy(req, PROXY)
}

function send (hotel, number, key) {
  const req = request()
  const params = {
    propertyId: hotel,
    bookingnumber: number,
    api_key: key
  }
  return req.get(TRAVELANIUM_API_URI, { params })
}

export default send
